import React from "react";

interface Props {}

// basically it does nothing, but it's a good abstraction
const Row: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default Row;
